/**
 * account.context.ts
 * Secured Communications
 *
 * Created by: Dylan Knight
 * Copyright (c) 2021 Secured Communications. All rights reserved.
 *
**/

import * as React from "react";

import { Account } from "../models/auth";

export interface AccountNavContext {
  toggleLeftNav(): void,
  currentAccount: Account | null,
  //toggleRightDetail(): void,
  //navTo(url: string, leaveRight?: boolean): void
}

export const AccountNavContext: React.Context<AccountNavContext> = React.createContext({
  toggleLeftNav: () => {},
  currentAccount: null as Account | null,
  //toggleRightDetail: () => {},
  //navTo: (_url: string, _leaveRight = false): void => {}
});

